import {
  Box,
  Button,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import { useCommandsModalContext } from '@src/components/Battery/Tesla/Commands/CommandsModalContext';
import useAlias from '@src/hooks/useAlias';
import { ServiceState } from '@src/store/reducers/serviceData';
import storeConnector from '@src/store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import isCommandsEnabled from '@src/utils/isCommandsEnabled';
import { useState } from 'react';
import tscSx from './TSCConfigSx';

interface TSCPointCellProps {
  label: string;
  pointValue: string | number | null | undefined;
  payload: string;
  siteMeta: SiteMeta;
  isControlsInterLocked: ServiceState['isControlsInterLocked'];
}

const StyledPointTableCell = styled(TableCell)({
  borderBottom: 0,
});

function TSCPointCell({
  label,
  pointValue,
  payload,
  isControlsInterLocked,
  siteMeta,
}: TSCPointCellProps) {
  const alias = useAlias();
  const [newValue, setNewValue] = useState<string>('');
  const { controlsLockConfig } = siteMeta.ui;
  const tooltipTitle = alias(
    'Controls disabled. {pointName} is above the threshold of {thresholdMax}.',
    {
      pointName: controlsLockConfig?.pointName,
      thresholdMax: controlsLockConfig?.thresholdMax,
    },
  );

  const { sendCommand } = useCommandsModalContext();
  const handleCommand = () => {
    sendCommand('WriteToVariant', {
      P: payload.replace('[input value]', newValue),
    });
    setNewValue('');
  };

  return (
    <TableRow>
      <StyledPointTableCell className='modes-cell'>
        {label}
      </StyledPointTableCell>
      <StyledPointTableCell className='modes-cell'>
        {pointValue}
      </StyledPointTableCell>
      <StyledPointTableCell className='modes-cell'>
        <TextField
          value={newValue}
          id='newTscValue'
          inputProps={{
            sx: tscSx.configTable.textField,
          }}
          onChange={(e) => {
            setNewValue(e.target.value);
          }}
        />
      </StyledPointTableCell>
      <StyledPointTableCell className='modes-cell' sx={tscSx.configSaveButton}>
        {isCommandsEnabled() && (
          <Tooltip
            title={isControlsInterLocked ? tooltipTitle : ''}
            placement='top'
            disableHoverListener={!isControlsInterLocked}
          >
            <Box>
              <Button
                variant='contained'
                disabled={isControlsInterLocked || newValue.length < 1}
                onClick={handleCommand}
              >
                <FormattedAlias id={'Save'} />
              </Button>
            </Box>
          </Tooltip>
        )}
      </StyledPointTableCell>
    </TableRow>
  );
}

export default storeConnector(TSCPointCell, {
  config: ['siteMeta'],
  service: ['isControlsInterLocked'],
});
